<template>

    <div class="login">
        <!-- 动态背景 -->
        <div class="background-animation">
            <div class="grid-background"></div>
            <div class="ecg-line ecg-line-1"></div>
            <div class="ecg-line ecg-line-2"></div>
            <div class="ecg-line ecg-line-3"></div>
            <div class="medical-cross cross-1"></div>
            <div class="medical-cross cross-2"></div>
            <div class="medical-cross cross-3"></div>
            <div class="particles">
                <div class="particle" v-for="n in 15" :key="n" :style="{ left: Math.random() * 100 + '%', animationDelay: Math.random() * 4 + 's' }"></div>
            </div>
        </div>
        <img src="@/assets/logo.png" alt="" class="logo">
        <!-- 登录表单 - 仅在配置加载成功时显示 -->
        <el-card v-if="configLoaded && !showConfigError" class="login-main" 
            :body-style="{'width': 'calc(100% - 80px)','padding': '0px 40px 0 40px','height:': '100%'}"> 
            <div class="title">
                {{ loginTitle }}
            </div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px">
                <el-form-item label="账号" prop="account">
                    <el-input ref="accountRef" type="text" style="width: 87%" placeholder="请输入帐号" v-model="ruleForm.account" @keyup.enter.native="switchFocus" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input ref="passwordRef" type="password" style="width: 87%" placeholder="请输入密码" v-model="ruleForm.password"  @keyup.enter.native="submitForm" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="rebme" class="rebme" >
                    <el-checkbox v-model="ruleForm.rebme">记住我</el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="loading" style="width: 87%" type="primary" @click="submitForm" class="login-button">
                        {{loading ? '登录中' : '登录'}}
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="version">v.{{ setting.version }}</div>
        </el-card>
        <!-- 配置加载中 -->
        <el-card v-if="configLoading" class="config-loading-main" 
            :body-style="{'width': 'calc(100% - 80px)','padding': '40px','height:': '100%'}">
            <div class="config-loading-content">
                <i class="el-icon-loading config-loading-icon"></i>
                <div class="config-loading-title">正在加载配置</div>
                <div class="config-loading-message">请稍候，正在加载应用配置...</div>
            </div>
        </el-card>
        <!-- 配置加载失败 -->
        <el-card v-if="showConfigError" class="config-error-main" 
            :body-style="{'width': 'calc(100% - 80px)','padding': '40px','height:': '100%'}">
            <div class="config-error-content">
                <i class="el-icon-error config-error-icon"></i>
                <div class="config-error-title">配置加载失败</div>
                <div class="config-error-message">{{ errorMessage || '加载应用配置时发生错误，请检查网络连接或稍后再试。' }}</div>
                <el-button type="primary" :loading="configReloading" @click="handleReloadConfig" class="retry-button">
                    <i class="el-icon-refresh" style="margin-right: 8px;"></i>
                    {{ configReloading ? '重试中...' : '重试' }}
                </el-button>
            </div>
        </el-card>
        <div class="detail">
            <a _ngcontent-rlx-c50="" v-if="!isMc" target="view_window" style="color: #fff">Copyright © 2023 - 2030 医匠 All Rights Reserved.</a>
            <a _ngcontent-rlx-c50="" v-if="isMc" target="view_window" href="https://beian.miit.gov.cn" style="margin-right: 20px;">晋ICP备17001123号</a>
            <a _ngcontent-rlx-c50="" v-if="isMc" target="view_window" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=14082602000062">晋公安网备14082602000062</a>
        </div>
    </div>
</template>

<script> 
import { getToken,getUserInfo } from '../services/user.service';
import { set,get, clear } from '@/utils/local';
import { getSetting } from '@/utils/dic';
import request from '@/utils/request';
import { setTenantId, clearTenantId, ADMIN_TENANT_ID } from '@/utils/tenant';
import { fetchApplicationConfiguration } from '@/utils/config';
import { getInstInfo } from '@/services/his.local.service';
import { hisShouldSyncSchedule, hisSyncFromHdis } from '@/services/his.patient';
import { hdisListPatients } from '@/services/his.hdis';

export default {
    name: 'LoginView',
    components: {
    },
    data() {
        let url = '';
        if (process.env.NODE_ENV === 'production') {
            url = window.globalConfig.rootUrl;
        } else {
            url = process.env.VUE_APP_BASE_URL;
        }
        return {
            isMc: url ? url.indexOf('magicalconch') != -1 : false,
            loading: false,
            setting: {},
            ruleForm: {
                account: '',
                password: '',
                rebme: false
            },
            sysInfoModel: {
                name: ''
            },
            hospitalName: '',
            showConfigError: false,
            configReloading: false,
            configLoading: true,
            configLoaded: false,
            errorMessage: '',
            rules: {
                account: [
                    { required: true, message: '输入账号', trigger: 'blur' },
                    { min: 3, max: 24, message: '长度在 3 到 24 个字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '输入密码', trigger: 'blur' },
                    { min: 6, max: 24, message: '长度在 6 到 24 个字符', trigger: 'blur' }
                ],
                rebme: [
                    { required: false, message: '输入密码', trigger: 'blur' }
                ]
            }
        };
    },
    created(){
    },
    async mounted(){ 
        await this.loadApplicationConfiguration();
        const cachedHospital = get('hospitalInfo');
        if (cachedHospital) {
            this.hospitalName = cachedHospital.name || cachedHospital.Name || '';
        }
        let localUser = get('localuser');
        if (localUser) {
            this.ruleForm = {...localUser};
        }
        this.setting = getSetting(); 
    },
    methods: {
        async loadApplicationConfiguration() {
            this.configLoading = true;
            this.configLoaded = false;
            this.showConfigError = false;
            this.errorMessage = '';
            
            let loadError = null;
            try {
                // 先初始化租户上下文（包括获取医院信息）
                await this.initializeTenantContext();
                // 再加载应用配置
                await fetchApplicationConfiguration(true);
                // 加载成功
                this.configLoaded = true;
                this.showConfigError = false;
            } catch (error) {
                console.error('Failed to load application configuration', error);
                loadError = error;
                // 设置错误消息
                if (error && error.message) {
                    this.errorMessage = error.message;
                } else if (error && typeof error === 'string') {
                    this.errorMessage = error;
                } else {
                    this.errorMessage = '加载应用配置时发生错误，请检查网络连接或稍后再试。';
                }
            } finally {
                this.configLoading = false;
            }

            if (loadError) {
                this.promptReloadApplicationConfiguration();
            }
        },
        promptReloadApplicationConfiguration() {
            // 显示错误窗口，隐藏登录窗口
            this.showConfigError = true;
        },
        async handleReloadConfig() {
            this.configReloading = true;
            try {
                await this.loadApplicationConfiguration();
                // loadApplicationConfiguration 内部已经处理了状态更新
            } catch (error) {
                // 如果仍然失败，保持错误窗口显示
                console.error('重新加载应用配置失败', error);
            } finally {
                this.configReloading = false;
            }
        },
        async initializeTenantContext() {
            console.log('initializeTenantContext');
            const host = window.location && window.location.hostname ? window.location.hostname : '';
            if (!host) {
                clearTenantId();
                clear('hospitalInfo');
                return;
            }
            const normalizedHost = host.toLowerCase(); 
            const domainParts = normalizedHost.split('.');
            const domain = domainParts[0] || '';
            const isAdminHost = domain === 'admin';
            if (isAdminHost) {
                setTenantId(ADMIN_TENANT_ID);  
                return;
            }
            clearTenantId();
            await this.fetchTenantByDomain(domain);
        },
        /**
         * 这个接口主要用于从本地医保服务直接获取医院信息，已弃用
         * 目前主设计是从租户接口获取医院信息
         */
        async loadInstInfo() { 
            try {
                const data = await getInstInfo();
                if (data && typeof data === 'object') {
                    // 将小驼峰字段名映射到原有字段名
                    const instInfo = {
                        id: data.id || data.Id || '',
                        name: data.name || data.Name || '',
                        level: data.level || data.Level || '',
                        admvs: data.admvs || data.Admvs || '',
                        region: data.region || data.Region || '',
                        code: data.code || data.Code || '',
                        registerTime: '',
                        instLevel: data.level || data.Level || '-',
                        webSiteName: data.webSiteName || data.WebSiteName || '',
                        hisLocalServiceUrl: data.hisLocalServiceUrl || data.HisLocalServiceUrl || '',
                        hdisApiUrl: data.hdisApiUrl || data.HdisApiUrl || '',
                        hdisSyncApiUrl: data.hdisSyncApiUrl || data.HdisSyncApiUrl || ''
                    };
                    set('hospitalInfo', instInfo);
                    this.hospitalName = instInfo.name || '';
                    return instInfo.webSiteName;
                } else {
                    // 获取不到，抛出错误
                    throw new Error('获取医院信息失败，请检查网络或稍后再试。');
                }
            } catch (error) {
                console.error('Failed to load inst info:', error);
                // 抛出错误，让上层处理
                throw new Error(error.message || '获取医院信息失败，请检查网络或稍后再试。');
            }
        },
        async fetchTenantByDomain(domain) {
            try {
                // localhost 或 URL 带 t=demo 时使用 demo 租户
                const urlT = typeof window !== 'undefined' && window.location && window.location.search
                    ? new URLSearchParams(window.location.search).get('t')
                    : null
                if (domain === 'localhost' || urlT === 'demo') {
                    domain = 'demo'
                }
                let response = await request({
                    url: `/api/app/tenants/by-name/${domain}`,
                    method: 'get'
                }); 
                const tenantHospital = response.hospital;
                if (!tenantHospital) {
                    throw new Error('获取医院信息失败，请检查网络或稍后再试');
                }
                const normalizedHospital = {
                    id: tenantHospital.id || tenantHospital.Id || '',
                    name: tenantHospital.name || tenantHospital.Name || '',
                    admvs: tenantHospital.admdvs || '',
                    code: tenantHospital.code || tenantHospital.Code || '',
                    registerTime: tenantHospital.registerTime || tenantHospital.RegisterTime || '',
                    instLevel: tenantHospital.instLevel || tenantHospital.InstLevel || '',
                    hisLocalServiceUrl: tenantHospital.hisLocalServiceUrl,
                    hdisApiUrl: tenantHospital.hdisApiUrl || tenantHospital.HdisApiUrl || '',
                    hdisSyncApiUrl: tenantHospital.hdisSyncApiUrl || tenantHospital.HdisSyncApiUrl || ''
                };
                this.sysInfoModel.name = normalizedHospital.name || '';
                set('hospitalInfo', normalizedHospital);
                const tenantId = this.resolveTenantId(response, tenantHospital);
                if (tenantId) {
                    setTenantId(tenantId);
                } else {
                    clearTenantId();
                }
                this.hospitalName = normalizedHospital.name || '';
            } catch (error) {
                clear('hospitalInfo');
                clearTenantId();
                // 抛出错误，让上层统一处理错误提示
                throw new Error(error.message || '获取租户信息失败，请检查网络或稍后再试');
            }
        },
        resolveTenantId(response, tenantHospital) {
            if (!response) {
                return '';
            }
            const directId = response.tenantId || response.tenantID || response.TenantId || response.TenantID;
            if (directId) {
                return directId;
            }
            const nestedTenant = response.tenant || response.Tenant;
            if (nestedTenant) {
                const nestedId = nestedTenant.tenantId || nestedTenant.tenantID || nestedTenant.id || nestedTenant.Id;
                if (nestedId) {
                    return nestedId;
                }
            }
            if (tenantHospital) {
                const hospitalTenantId = tenantHospital.tenantId || tenantHospital.tenantID || tenantHospital.TenantId || tenantHospital.TenantID;
                if (hospitalTenantId) {
                    return hospitalTenantId;
                }
            }
            if (response.id && typeof response.id === 'string') {
                return response.id;
            }
            return '';
        },
        switchFocus() {
            // 使当前input失去焦点
            this.$refs.accountRef.blur();
            // 使input2获得焦点
            this.$refs.passwordRef.focus();
        },
        jumpHome(ures){
            if (ures && ures.isAdmin == true) {
                this.$router.push('/home');
            } else {
                this.$router.push('/index');
            }
            // 登录成功后静默触发排班同步检查
            this.silentScheduleSync();
        },
        /**
         * 静默同步排班（后台执行，不影响用户操作）
         * 检查是否需要同步，如果需要则自动执行同步
         */
        async silentScheduleSync() {
            try {
                // 1. 检查是否需要同步
                const shouldSync = await hisShouldSyncSchedule();
                if (!shouldSync) {
                    return;
                }
                // 2. 分页获取 HDIS 患者列表
                let allPatients = [];
                let pageIndex = 1;
                const pageSize = 200;
                let hasMore = true;
                while (hasMore) {
                    const res = await hdisListPatients({ pageIndex, pageSize });
                    const items = Array.isArray(res) ? res : [];
                    allPatients = allPatients.concat(items);
                    hasMore = items.length >= pageSize;
                    pageIndex++;
                }
                if (allPatients.length === 0) {
                    return;
                }
                // 3. 转换数据格式并调用同步接口
                const syncItems = allPatients.map(row => ({
                    hdisPatientId: row.id || '',
                    patientName: row.patientName || '',
                    patientSex: row.patientSex || '',
                    patientBirthday: row.patientBirthday || null,
                    cardNum: row.cardNum || '',
                    dialysisId: row.dialysisId || '',
                    contactPhone: row.contactPhone || '',
                    mailingAddress: row.mailingAddress || '',
                    scheduleClassName: row.scheduleClassName || '',
                    scheduleClassTime: row.scheduleClassTime || '',
                    treatmentMode: row.treatmentMode || '',
                    areaName: row.areaName || ''
                }));
                await hisSyncFromHdis({ items: syncItems });
            } catch (e) {
                // 静默失败，不做任何处理
                console.warn('静默同步排班失败:', e);
            }
        },
        submitForm() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.login();
                } else {
                    this.$message.warning('请输入正确的登录信息');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 登录
        login(){
            this.loading = true;
            let params = new URLSearchParams()
            let clientId = 'Api_App';
            if (process.env.NODE_ENV === 'production') {
                clientId = window.globalConfig.clientId;
            }
            params.append('grant_type', 'password')
            params.append('client_id', clientId)
            params.append('password', this.ruleForm.password)
            params.append('username', this.ruleForm.account)
            params.append('scope', 'Api offline_access')
            getToken(params).then(res => {
                set('token', res, res.expires_in);
                // 是否缓存
                if (this.ruleForm.rebme) {
                    set('localuser', this.ruleForm);
                } else {
                    clear('localuser');
                }
                getUserInfo().then(ures =>{
                    set('user', ures, res.expires_in);
                    this.loading = false;
                    this.$message.success('欢迎登录医匠,' + ures.name);
                    this.jumpHome(ures);
                }, () => {
                    this.$message.error('获取用户信息失败');
                    this.loading = false;
                });
            }, () => {
                this.$message.error('登录失败');
                this.loading = false;
            });
        }
    },
    computed: {
        loginTitle() {
            return this.hospitalName ? `${this.hospitalName}登录` : '医匠登录';
        }
    }
}
</script>

<style lang="scss" scoped> 
.login {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    background: linear-gradient(135deg, 
        #0a1e3a 0%, 
        #0f2b4d 15%, 
        #1a3a6b 30%, 
        #2563eb 45%, 
        #1e4a7a 60%, 
        #0f2b4d 75%, 
        #0a1e3a 100%
    );
    background-size: 400% 400%;
    animation: gradientShift 20s ease infinite;
}

@keyframes gradientShift {
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
}

// 动态背景容器
.background-animation {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    overflow: hidden;
}

// 网格背景
.grid-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
        linear-gradient(rgba(64, 158, 255, 0.15) 1px, transparent 1px),
        linear-gradient(90deg, rgba(64, 158, 255, 0.15) 1px, transparent 1px);
    background-size: 50px 50px;
    animation: gridMove 20s linear infinite;
    opacity: 0.4;
}

@keyframes gridMove {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(50px, 50px);
    }
}

// 心电图线条
.ecg-line {
    position: absolute;
    height: 3px;
    opacity: 0.5;
    background: linear-gradient(90deg, 
        transparent 0%,
        rgba(64, 158, 255, 0.3) 20%,
        rgba(64, 158, 255, 0.6) 40%,
        rgba(64, 158, 255, 0.8) 50%,
        rgba(64, 158, 255, 0.6) 60%,
        rgba(64, 158, 255, 0.3) 80%,
        transparent 100%
    );
    box-shadow: 0 0 10px rgba(64, 158, 255, 0.4);
    animation: ecgPulse 2s ease-in-out infinite;
}

.ecg-line-1 {
    top: 20%;
    left: -100%;
    width: 400px;
    animation: ecgMove1 12s linear infinite, ecgPulse 2s ease-in-out infinite;
}

.ecg-line-2 {
    top: 50%;
    left: -100%;
    width: 500px;
    animation: ecgMove2 15s linear infinite, ecgPulse 2.5s ease-in-out infinite;
    animation-delay: 2s;
}

.ecg-line-3 {
    top: 80%;
    left: -100%;
    width: 450px;
    animation: ecgMove3 18s linear infinite, ecgPulse 3s ease-in-out infinite;
    animation-delay: 4s;
}

@keyframes ecgMove1 {
    0% {
        left: -100%;
    }
    100% {
        left: 100%;
    }
}

@keyframes ecgMove2 {
    0% {
        left: -100%;
    }
    100% {
        left: 100%;
    }
}

@keyframes ecgMove3 {
    0% {
        left: -100%;
    }
    100% {
        left: 100%;
    }
}

@keyframes ecgPulse {
    0%, 100% {
        opacity: 0.3;
        transform: scaleY(1);
    }
    50% {
        opacity: 0.7;
        transform: scaleY(1.8);
    }
}

// 医疗十字
.medical-cross {
    position: absolute;
    width: 50px;
    height: 50px;
    opacity: 0.2;
    animation: crossFloat 10s ease-in-out infinite;
    filter: blur(0.5px);
}

.medical-cross::before,
.medical-cross::after {
    content: '';
    position: absolute;
    border-radius: 2px;
}

.medical-cross::before {
    width: 3px;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(180deg, 
        transparent 0%,
        rgba(64, 158, 255, 0.5) 20%,
        rgba(64, 158, 255, 0.7) 50%,
        rgba(64, 158, 255, 0.5) 80%,
        transparent 100%
    );
    box-shadow: 0 0 10px rgba(64, 158, 255, 0.5);
}

.medical-cross::after {
    width: 100%;
    height: 3px;
    top: 50%;
    transform: translateY(-50%);
    background: linear-gradient(90deg, 
        transparent 0%,
        rgba(64, 158, 255, 0.5) 20%,
        rgba(64, 158, 255, 0.7) 50%,
        rgba(64, 158, 255, 0.5) 80%,
        transparent 100%
    );
    box-shadow: 0 0 10px rgba(64, 158, 255, 0.5);
}

.cross-1 {
    top: 15%;
    left: 10%;
    animation-delay: 0s;
}

.cross-2 {
    top: 60%;
    right: 15%;
    animation-delay: 2s;
    animation-duration: 10s;
}

.cross-3 {
    bottom: 20%;
    left: 20%;
    animation-delay: 4s;
    animation-duration: 12s;
}

@keyframes crossFloat {
    0%, 100% {
        transform: translate(0, 0) rotate(0deg);
        opacity: 0.1;
    }
    25% {
        transform: translate(20px, -20px) rotate(5deg);
        opacity: 0.2;
    }
    50% {
        transform: translate(-10px, -30px) rotate(-5deg);
        opacity: 0.15;
    }
    75% {
        transform: translate(-20px, 10px) rotate(3deg);
        opacity: 0.2;
    }
}

// 粒子效果
.particles {
    position: absolute;
    width: 100%;
    height: 100%;
}

.particle {
    position: absolute;
    width: 3px;
    height: 3px;
    border-radius: 50%;
    animation: particleFloat 8s ease-in-out infinite;
}

.particle:nth-child(odd) {
    background: rgba(64, 158, 255, 0.5);
    box-shadow: 0 0 10px rgba(64, 158, 255, 0.6);
}

.particle:nth-child(even) {
    background: rgba(100, 181, 246, 0.5);
    box-shadow: 0 0 10px rgba(100, 181, 246, 0.6);
}

.particle:nth-child(3n) {
    background: rgba(66, 165, 245, 0.4);
    box-shadow: 0 0 8px rgba(66, 165, 245, 0.5);
}

@keyframes particleFloat {
    0% {
        transform: translateY(100vh) translateX(0) scale(0);
        opacity: 0;
    }
    10% {
        opacity: 0.8;
    }
    50% {
        transform: translateY(50vh) translateX(20px) scale(1);
        opacity: 1;
    }
    90% {
        opacity: 0.8;
    }
    100% {
        transform: translateY(-100px) translateX(-20px) scale(0);
        opacity: 0;
    }
}
.login-main {
    width: 580px; 
    height: 450px; 
    display: flex;
    flex-direction: column; 
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 10;
    border-radius: 16px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.98) 100%);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    box-shadow: 
        0 8px 32px rgba(0, 0, 0, 0.1),
        0 2px 8px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.3);
    overflow: hidden;
    animation: fadeInUp 0.6s ease-out;
    transition: all 0.3s ease;
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: linear-gradient(90deg, 
            #409EFF 0%, 
            #66b1ff 25%, 
            #79bbff 50%, 
            #66b1ff 75%, 
            #409EFF 100%
        );
        background-size: 200% 100%;
        animation: gradient 3s ease infinite;
    }
    
    &:hover {
        box-shadow: 
            0 12px 40px rgba(0, 0, 0, 0.12),
            0 4px 12px rgba(0, 0, 0, 0.1),
            inset 0 1px 0 rgba(255, 255, 255, 0.9);
        transform: translateY(-2px);
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes gradient {
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
}
.el-card__body {
    height: 100% !important;
    width: 100% !important;
    padding: 0;
}

// 优化表单样式
.login-main {
    ::v-deep .el-form-item__label {
        color: #606266;
        font-weight: 500;
    }
    
    ::v-deep .el-input__inner {
        border-radius: 8px;
        border: 1px solid #DCDFE6;
        transition: all 0.3s ease;
        
        &:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
        }
    }
    
    ::v-deep .el-button {
        border-radius: 8px;
        font-weight: 500;
        transition: all 0.3s ease;
        height: 44px;
        font-size: 16px;
        
        &:not(.is-disabled):hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
        }
    }
    
    ::v-deep .login-button {
        background: linear-gradient(135deg, #409EFF 0%, #66b1ff 50%, #79bbff 100%);
        border: none;
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
        
        &:not(.is-disabled):hover {
            background: linear-gradient(135deg, #66b1ff 0%, #79bbff 50%, #a0cfff 100%);
            box-shadow: 0 6px 16px rgba(64, 158, 255, 0.4);
        }
        
        &:not(.is-disabled):active {
            transform: translateY(0);
        }
    }
    
    ::v-deep .el-checkbox__label {
        color: #606266;
        font-weight: 400;
    }
}
.title {
    width: 100%;
    font-size: 28px;
    height: 75px;
    font-weight: 600;
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 50%, #79bbff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    letter-spacing: 1px;
}
.name {
    width: 100%;
    font-size: 14px;
    height: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #909399;
    font-weight: 400;
    margin-top: 8px;
}

.detail {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    padding: 10px 24px;
    background: rgba(64, 158, 255, 0.1);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 24px;
    border: 1px solid rgba(64, 158, 255, 0.2);
    box-shadow: 
        0 2px 8px rgba(0, 0, 0, 0.1),
        0 0 15px rgba(64, 158, 255, 0.15);
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    white-space: nowrap;

    a {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.9);
        text-decoration: none;
        text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
        transition: all 0.3s ease;
        letter-spacing: 0.5px;
        display: inline-block;
        
        &:hover {
            color: rgba(255, 255, 255, 1);
            text-shadow: 0 0 8px rgba(64, 158, 255, 0.6);
            transform: translateY(-1px);
        }
    }
    
    &:hover {
        background: rgba(64, 158, 255, 0.15);
        border-color: rgba(64, 158, 255, 0.4);
        box-shadow: 
            0 4px 12px rgba(0, 0, 0, 0.15),
            0 0 20px rgba(64, 158, 255, 0.25);
    }
}

.logo {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 66px;
    height: 66px;
    z-index: 10;
    padding: 8px;
    background: rgba(64, 158, 255, 0.1);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 12px;
    border: 1px solid rgba(64, 158, 255, 0.3);
    box-shadow: 
        0 4px 12px rgba(0, 0, 0, 0.15),
        0 0 20px rgba(64, 158, 255, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
    box-sizing: border-box;
    
    &:hover {
        background: rgba(64, 158, 255, 0.15);
        border-color: rgba(64, 158, 255, 0.5);
        box-shadow: 
            0 6px 16px rgba(0, 0, 0, 0.2),
            0 0 30px rgba(64, 158, 255, 0.3),
            inset 0 1px 0 rgba(255, 255, 255, 0.2);
        transform: translateY(-2px);
    }
}
.version {
    position: absolute;
    bottom: 10px;
    right: 10px;
    font-size: 10px;
    color: #cccccc;
}
.config-loading-main {
    width: 580px; 
    height: 450px; 
    display: flex;
    flex-direction: column; 
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 10;
    border-radius: 16px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.98) 100%);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    box-shadow: 
        0 8px 32px rgba(0, 0, 0, 0.1),
        0 2px 8px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.3);
    overflow: hidden;
    animation: fadeInUp 0.6s ease-out;
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: linear-gradient(90deg, 
            #409EFF 0%, 
            #66b1ff 25%, 
            #79bbff 50%, 
            #66b1ff 75%, 
            #409EFF 100%
        );
        background-size: 200% 100%;
        animation: gradient 3s ease infinite;
    }
}
.config-loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}
.config-loading-icon {
    font-size: 64px;
    color: #409EFF;
    margin-bottom: 24px;
    animation: rotating 2s linear infinite;
}
@keyframes rotating {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
.config-loading-title {
    font-size: 24px;
    font-weight: 550;
    color: #303133;
    margin-bottom: 16px;
}
.config-loading-message {
    font-size: 14px;
    color: #909399;
    line-height: 1.5;
}
.config-error-main {
    width: 580px; 
    height: 450px; 
    display: flex;
    flex-direction: column; 
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 10;
    border-radius: 16px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.98) 100%);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    box-shadow: 
        0 8px 32px rgba(0, 0, 0, 0.1),
        0 2px 8px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.3);
    overflow: hidden;
    animation: fadeInUp 0.6s ease-out;
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: linear-gradient(90deg, #F56C6C 0%, #E6A23C 50%, #F56C6C 100%);
        background-size: 200% 100%;
        animation: gradient 3s ease infinite;
    }
}
.config-error-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}
.config-error-icon {
    font-size: 72px;
    color: #F56C6C;
    margin-bottom: 24px;
    animation: shake 0.5s ease-in-out;
}
@keyframes shake {
    0%, 100% {
        transform: translateX(0);
    }
    25% {
        transform: translateX(-5px);
    }
    75% {
        transform: translateX(5px);
    }
}
.config-error-title {
    font-size: 24px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 16px;
}
.config-error-message {
    font-size: 14px;
    color: #606266;
    line-height: 1.8;
    margin-bottom: 8px;
    max-width: 400px;
}
.retry-button {
    margin-top: 32px;
    width: 180px;
    height: 44px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 4px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}
.retry-button:hover {
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
    transform: translateY(-1px);
}

</style>